/* Signup destination is deferred. This review build cannot transmit signup data. */
(()=>{'use strict';window.BEAM_QUIZ_EMAIL_ADAPTER=Object.freeze({configured:false,async submit(){return {accepted:false,category:'unavailable'};}});})();
